import {ICustomersState} from '../../../api/customers/types';

export const selectCustomers = (state: ICustomersState) => state.customers.data.customers.result;
export const selectTotalRecords = (state: ICustomersState) => state.customers.data.customers.page.total;
export const selectCustomer = (state: ICustomersState) => state.customers.data.selectedCustomer;
export const selectBillingDetails = (state: ICustomersState) => state.customers.data.billingDetails;
export const selectBillingHistory = (state: ICustomersState) => state.customers.data.billingHistory.result;
export const selectBillingHistoryTotal = (state: ICustomersState) => state.customers.data.billingHistory.page.total;
export const selectSubscriptions = (state: ICustomersState) => state.customers.data.subscriptions;
